import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import type { IntroOffersAlertBody } from '../alertHover.types'
import { introOffersStyles } from './IntroOffers.styles'

const IntroOffersBody: React.FC<{ body: IntroOffersAlertBody }> = ({ body }) => {
  const offers = body ?? []
  if (!offers.length) return null

  const text = offers.join(', ')

  return (
    <Box sx={introOffersStyles.root}>
      <Typography sx={introOffersStyles.item}>{text}</Typography>
    </Box>
  )
}

export default IntroOffersBody
